import { Stack } from '@mui/system';

import NodeIndicator, { Props as NodeIndicatorProps } from './NodeIndicator';

export type Props = {
  indicators: Array<NodeIndicatorProps>;
  rightAlign?: boolean;
};

const NodeIndicators = ({
  indicators,
  rightAlign,
}: Props): JSX.Element | null => {
  if (!indicators.length) return null;

  return (
    <Stack direction="row" justifyContent={rightAlign ? 'end' : 'center'}>
      {indicators.map((indicator) => (
        <NodeIndicator
          key={
            Array.isArray(indicator.message)
              ? indicator.message.join()
              : indicator.message
          }
          icon={indicator.icon}
          message={indicator.message}
          iconColor={indicator.iconColor}
        />
      ))}
    </Stack>
  );
};

export default NodeIndicators;
